module.exports = __webpack_public_path__ + "static/media/cherry1.467f8020.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/cherry1.svg
// module id = 1394
// module chunks = 0